import { SignalWifi1Bar, SignalWifi2Bar, SignalWifiStatusbarNull, Wifi } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import NoSignalIcon from '../../../../../components/ui-icons/no-signal'
import SignalIcon from '../../../../../components/ui-icons/signal'

const SignalIndicatorItem = ({ value, nodeTypeName }: { value: number; nodeTypeName: string }) => {
  const theme = useTheme()

  const { ariaLabel, IconComponent } = {
    0: {
      ariaLabel: 'No signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => (
        <NoSignalIcon color={theme.palette.warning.light} secondaryColor={theme.palette.ui.surfaceDim} aria-label={iconAriaLabel} />
      ),
    },
    1: {
      ariaLabel: 'Weak signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => <SignalIcon value={value} ariaLabel={iconAriaLabel} />,
    },
    2: {
      ariaLabel: 'Weak signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => <SignalIcon value={value} ariaLabel={iconAriaLabel} />,
    },
    3: {
      ariaLabel: 'Fair signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => <SignalIcon value={value} ariaLabel={iconAriaLabel} />,
    },
    4: {
      ariaLabel: 'Good signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => <SignalIcon value={value} ariaLabel={iconAriaLabel} />,
    },
    5: {
      ariaLabel: 'Excellent signal',
      IconComponent: ({ 'aria-label': iconAriaLabel }: { 'aria-label': string }) => <SignalIcon value={value} ariaLabel={iconAriaLabel} />,
    },
  }[value] ?? { ariaLabel: 'Unknown', IconComponent: () => <>-</> }

  if (nodeTypeName !== 'kerlink_wifi_gateway') return <IconComponent aria-label={ariaLabel} />
  return (
    <>
      {value === 0 && <SignalWifiStatusbarNull htmlColor={theme.palette.ui.surfaceDim} aria-label={ariaLabel} />}
      {value === 1 && <SignalWifi1Bar htmlColor={theme.palette.warning.light} aria-label={ariaLabel} />}
      {value === 2 && <SignalWifi2Bar htmlColor={theme.palette.warning.light} aria-label={ariaLabel} />}
      {value === 3 && <SignalWifi2Bar htmlColor={theme.palette.success.main} aria-label={ariaLabel} />}
      {value === 4 && <Wifi htmlColor={theme.palette.success.main} aria-label={ariaLabel} />}
      {value === 5 && <Wifi htmlColor={theme.palette.success.main} aria-label={ariaLabel} />}
    </>
  )
}

export default SignalIndicatorItem
